<app-material>
    <div class="header" header>
        <h2>{{ 'admin.valueStreams.table.title' | translate }}</h2>

        <app-button *ngIf="shouldRenderModifiers()"
                    (clicked)="openModal()">
            {{ 'admin.valueStreams.buttons.add' | translate }}
        </app-button>
    </div>

    <ng-container body>
        <app-value-streams-table
            [valueStreams]="valueStreams"
            [isLoading]="isLoading"
            [tableConfig]="tableConfig"
            [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
            (sortChange)="onSortChange($event)"
            (filterChange)="onFilter($event)"
            (rowClick)="onTableRowClick($event)"
            (duplicateRow)="onDuplicateRow($event)"
            (pageChange)="onPageChange($event)">
        </app-value-streams-table>
    </ng-container>
</app-material>

<app-value-stream-create-modal
    [isLoading]="isLoading"
    (onCreate)="create($event)"
    (onUpdate)="update($event)"
    (onDelete)="remove($event)">
</app-value-stream-create-modal>
